import { useRouter } from "next/navigation";
import { toast } from "shared-components";
import { useAuthStore } from "@/stores/use-auth-store";
import { useUserStore } from "@/stores/use-user-store";
import { captureCurrentRoute } from "@/utils/auth-route";

export const useAuthGuard = () => {
  const { activeUser } = useUserStore();
  const { setOnAuthRoute } = useAuthStore();
  const router = useRouter();

  const isAuthenticated = (showToast = false) => {
    if (!activeUser) {
      if (showToast) {
        toast.error("Você precisa estar logado para realizar esta ação.");
      }
      setOnAuthRoute(captureCurrentRoute());
      router.push("/login");
      return false;
    }
    return true;
  };

  return { isAuthenticated };
};
